import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../constants";

const ProfileCompletion = () => {
  const [completion, setCompletion] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCompletion = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (!token) {
          setError("No authentication token found.");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          API_URL+"profile_actions/me/completion/",
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        );
        setCompletion(response.data.completion_percentage);
      } catch (err) {
        setError("Failed to load profile completion.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCompletion();
  }, []);

  if (loading) {
    return <div className="text-center py-4">Loading profile completion...</div>;
  }

  if (error) {
    return <div className="text-center py-4 text-red-500">Error: {error}</div>;
  }

  if (completion === 100) {
    return null; // Don't show if profile is 100% complete
  }

  return (
    <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-6" role="alert">
      <p className="font-bold">Profile Completion: {completion}%</p>
      <p>Complete your profile to unlock all features. Go to <a href="/profile" className="font-bold underline">Profile Settings</a>.</p>
      <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mt-2">
        <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${completion}%` }}></div>
      </div>
    </div>
  );
};

export default ProfileCompletion;
